import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PopupDialogService {

  public data: any;
  public type: number;

  constructor() { }

  showPopupDialog(data: any, type: number = 0) {
    this.data = data;
    this.type = type;
  }

  closeDialog() {
    this.data = null;
  }
}
